import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { MatchScoreWidget } from "../../../../frontend/templates/_partials/MatchScoreWidget/Index";
import borderFrame from '../../../../frontend/templates/fcb/ResultsNew/images/border_BG_empty.png'
import getContentById from "../../../utils/getContentById";
import { formatMinute, parseMinute, sortByTimeFirst } from "../../../../frontend/templates/fcb/ResultsNew/Index";
import { PresetColors } from "./LeftSidebar/EditTab";
import { useTranslation } from "react-i18next";
import { getOneLetterResult } from "../../../../frontend/templates/fcb/MatchdaySlider/Index";
import TeamLogo from "../../../../frontend/templates/_partials/TeamLogo";

const FCBSlider4Content = ({ data, ...props }) => {
    const templateName = data?.template_name ?? "";
    const id = `${templateName}_${data?.uuid}`;

    const { options, fields, dynamic, editData } = data.data;
    const {
        timezones,
    } = data?.data?.dynamic;

    const date = data?.event?.date;
    const time = data?.event?.time;
    const [day, month, year] = date.split(".");
    const dateTimeString = `${year}-${month}-${day}T${time}`;
    const basetime = new Date(dateTimeString);

    const { t } = useTranslation();
    const selectedLang = data?.lang;

    return (
        <div id={id} className="T_fcb_matchday_slider_3" style={{ zIndex: 101 }}>
            <div className={"wc-content wc-content-v2"}
                style={{
                    transform: 'scale(0.41)',
                    left: -355,
                    color: 'white',
                    zIndex: 1
                }}

            >
                <div className="first-bottom-container">
                    <div className={`logo-container`}>
                        <div className="label-match-info-glow">
                            {t("Watch Time", { keyPrefix: "table", lng: selectedLang })}
                        </div>
                        <div className="label-match-info">
                            {t("Watch Time", { keyPrefix: "table", lng: selectedLang })}
                        </div>
                    </div>
                    <div class="time-container">
                        <div class="time-series">
                            <div class="right">
                                {timezones?.map(({ city, timezone }, index) => {
                                    const localTime = basetime?.toLocaleString("en-US", {
                                        timeZone: timezone,
                                        hour: "numeric",
                                        minute: "numeric",
                                        hour12: true,
                                    });
                                    if (city === 'Munich') {
                                        return <div className="base-time">
                                            <span class="time">{localTime}</span>
                                            <span class="city">{t(city, { keyPrefix: "table", lng: selectedLang })}</span>
                                        </div>
                                    }
                                    return (
                                        <div class="time-row">
                                            <span class="time">{localTime}</span>
                                            <span class="city">{t(city, { keyPrefix: "table", lng: selectedLang })}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="gradient-image"></div>
            </div>
        </div>

    );
};

export default FCBSlider4Content;
